module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAPCAYAAADd/14OAAAABHNCSVQICAgIfAhkiAAAARVJREFUKJFtkr9KQzEYxU8utxepmzpZO7oK6uIiiKiLw3WpoNRF38GH6DOIi7qoiy7Sqb6BL3BBEJysHcQ/N+brdxxCJW1u4AxJfvxCTmJsa+swMbwCAVLPs9veCSpGkqh0KAKKA0WOf/fWLypBFWl40Eeda9vdtesIpHP0tlEE6lyr3F65C0Hzs7OqAA1IkASCEOzWp8rcPBTWfG8uKUgDIAZJAHycdsM8pYjfQGhECG58gp2U4uCr8XBk9OvL/0YPohI04NM4OGH1U+2JHZ6OHz0BKtl9l0G+WMDGRsJfTPV+pvjIRz2mFIk6JHkz+/y1HxaeqrhXkI2gksu5l/IoeuxBMzvoNzP2F2p8m6+dVX0IAPgDXiUNG9en+ocAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img23.png
// module id = 9+ee
// module chunks = 1